module.exports = __webpack_public_path__ + "static/Glober_xBold-8370643840918800b0023d58ecbd6493.woff2";